<template>
  <teleport to="#modalTeleport">
    <TemplateCropModal
      v-if="voucher.imgData || voucher.png"
      :image="voucher.imgData"
      :initialBounds="ticketTemplate.voucher_bounds"
      :png="voucher.png"
      @cancel="voucher.png = ''"
      @crop="cropVoucherTemplate"
      :aspectRatio="180 / 242"
      title="QR und Datenbereich definieren"
    ></TemplateCropModal>
    <TemplateCropModal
      v-if="badge.imgData || badge.png"
      :image="badge.imgData"
      :initialBounds="ticketTemplate.badge_bounds"
      :png="badge.png"
      @cancel="badge.png = ''"
      @crop="cropBadgeTemplate"
      :aspectRatio="57 / 16"
      title="Beschriftungsbereich definieren"
    ></TemplateCropModal>
  </teleport>
  <HeadlineComponent>Neues Ticket Template anlegen</HeadlineComponent>
  <Form
    class="form-horizontal"
    @submit="create"
    v-if="dataLoaded"
    :initialValues="form"
  >
    <div class="form-group">
      <label for="name">Name</label>
      <BootstrapField type="text" name="name" placeholder="Name" />
    </div>
    <div class="form-group">
      <label for="subject">E-Mail Betreff</label>
      <BootstrapField type="text" name="subject" placeholder="Dein Ticket" />
    </div>
    <div class="form-group">
      <QuillField
        name="text"
        placeholder="Hier ist dein Ticket..."
        label="E-Mail Text"
      />
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="pdf">PDF Template</label>
          <input
            type="file"
            class="form-control"
            id="pdf"
            accept="application/pdf"
            @change="handleFileUpload('voucher', $event)"
            :class="{ 'is-invalid': voucherToBig }"
          />
          <small class="form-text" :class="{ 'invalid-feedback': voucherToBig }"
            ><strong>Format: PDF 1.4</strong><br />Maximale Größe: 2Mb. Bedenke: Jedem Ticketinhaber wird diese PDF
            per Mail zugeschickt und im schlimmsten Fall müssen sie die PDF vor
            Ort mit schlechtem Internet herunterladen. Je kleiner desto
            besser.</small
          >
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="badge">Badge Template</label>
          <input
            type="file"
            class="form-control"
            id="badge"
            accept="application/pdf"
            @change="handleFileUpload('badge', $event)"
          />
           <small class="form-text" :class="{ 'invalid-feedback': voucherToBig }"
            ><strong>Format: PDF 1.4</strong></small
          >
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="form-check">
        <Field
          type="checkbox"
          class="form-check-input"
          id="crewtemplate"
          :value="true"
          name="crewtemplate"
        />
        <label class="form-check-label" for="crewtemplate">
          Dieses Template ist für normale Crew Tickets
        </label>
      </div>
      <div class="form-text">
        Wenn der Haken gesetzt ist, wird dieses Template dafür benutzt Tickets
        für die normale Crew zu generieren.
      </div>
    </div>
    <LoadingButton class="btn-primary" :loading="loading"
      >Anlegen</LoadingButton
    >
  </Form>
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import TemplateCropModal from "@/components/TemplateCropModal.vue";
import ticketService from "@/services/ticket.service.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import QuillField from "../../components/QuillField.vue";
import { Field, Form } from "vee-validate";
import BootstrapField from "../../components/BootstrapField.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "CreateTicketTemplateView",
  components: {
    LoadingButton,
    HeadlineComponent,
    TemplateCropModal,
    QuillField,
    // eslint-disable-next-line vue/no-reserved-component-names
    Form,
    Field,
    BootstrapField,
  },
  data() {
    return {
      form: {
        crewtemplate: false,
        subject: "",
        text: "",
        name: ""
      },
      voucherToBig: false,
      voucher: {
        file: "",
        png: "",
        imgData: "",
        imgFormData: "",
      },
      badge: {
        file: "",
        png: "",
        imgData: "",
        imgFormData: "",
      },
      loading: false,
      dataLoaded: false,
      ticketTemplate: {
        voucher_bounds: {},
        badge_bounds: {},
      },
    };
  },
  async beforeMount() {
    if (this.$route.params.id) {
      try {
        let response = await ticketService.getTicketTemplate(
          this.$route.params.event,
          this.$route.params.id
        );
        this.form.name = response.data.name;
        this.form.subject = response.data.subject;
        this.form.text = response.data.text;
        this.form.crewtemplate = false;
        this.ticketTemplate.voucher_bounds = response.data.voucher_bounds;
        this.ticketTemplate.badge_bounds = response.data.badge_bounds;
        this.dataLoaded = true;
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    }
    this.dataLoaded = true;
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async create(values) {
      this.loading = true;
      try {
        values.voucher_bounds = this.ticketTemplate.voucher_bounds;
        values.badge_bounds = this.ticketTemplate.badge_bounds;
        await ticketService.createTicketTemplate(
          this.$route.params.event,
          values,
          this.voucher,
          this.badge
        );
        this.addAlert("success", "Ticket template erfolgreich hinzugefügt");
        this.$router.push(
          `/events/${this.$route.params.event}/ticketTemplates`
        );
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          console.log(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
    handleFileUpload(type, event) {
      if (type === "voucher") {
        if (event.target.files[0].size > 2 * 1024 * 1024) {
          this.addAlert(
            "danger",
            "Die Voucher PDF darf maximal 2Mb groß sein."
          );
          window.scrollTo(0, 0);
          this.voucherToBig = true;
          return;
        } else {
          this.voucherToBig = false;
        }
      }

      this[type].file = event.target.files[0];
      let reader = new FileReader();
      reader.onload = (event) => {
        this[type].imgData = event.target.result;
      };
      reader.readAsArrayBuffer(this[type].file);
    },
    cropVoucherTemplate(res) {
      let bounds = res.bounds;
      this.ticketTemplate.voucher_bounds.x = bounds.x;
      this.ticketTemplate.voucher_bounds.y = bounds.y;
      this.ticketTemplate.voucher_bounds.w = bounds.w;
      this.ticketTemplate.voucher_bounds.h = bounds.h;
      if (!this.voucher.png) {
        this.voucher.imgData = "";
        this.voucher.imgFormData = res.image;
      } else {
        this.voucher.png = "";
      }
    },
    cropBadgeTemplate(res) {
      let bounds = res.bounds;
      this.ticketTemplate.badge_bounds.x = bounds.x;
      this.ticketTemplate.badge_bounds.y = bounds.y;
      this.ticketTemplate.badge_bounds.w = bounds.w;
      this.ticketTemplate.badge_bounds.h = bounds.h;
      if (!this.badge.png) {
        this.badge.imgData = "";
        this.badge.imgFormData = res.image;
      } else {
        this.badge.png = "";
      }
    },
  },
};
</script>

<style scoped></style>
